import PropTypes from 'prop-types';
import conectaImg from 'assets/img/conecta-img.png';

export function SvgLogo ({ width, height }) {
  return (
    <img src={conectaImg} alt="svg logo" width={width} height={height} />
  );
}

SvgLogo.propTypes = {
  height: PropTypes.string,
  width: PropTypes.string
};
